import React, { useEffect, useState } from "react";
import "./PartnerDashboard.css";
import "../CETDashBoard/CETDashBoard.css";
import { Col, Row } from "react-bootstrap";
import { Routes, Route, Navigate } from "react-router-dom";
import SideMenuPartnerDashboard from "./SideMenuPartnerDashboard";
import { connect } from "react-redux";
import { useSelector } from "react-redux";
import "../Common/CommonStyle.css";
import useWindowSize from "../../utils/useWindowSize";
import PartnerMobileHeader from "./PartnerMobileHeader";
import { Spin, message, notification } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import CustomLogout from "./../CustomLogout/CustomLogout";
import useSession from "../CustomLogout/useSession";
import PartnerTeamDetails from "../PartnerTeamDetails/PartnerTeamDetails";
import {
  getSideBarBranch,
  getTeamSideBarDetails,
} from "../../redux/SideBarTeams/action";
import { getPartnerSidebar } from "../../redux/PartnerSidebar/PartnerSidebarAction";
import UseFullLoader from "../FullPageLoader/UseFullLoader";
import { GetBranchCountDetails } from "../../redux/BranchCount/action";
import UserManagement from "../UserManagement/UserManagement";

const EngagementDetails = React.lazy(() =>
  import("../EngagementDetails/EngagementDetails")
);

const FirmDetails = React.lazy(() => import("../FirmDetails/FirmDetails"));
const BranchDetails = React.lazy(() =>
  import("../BranchDetails/BranchDetails")
);
const DocumentsDetails = React.lazy(() =>
  import("../DocumentsDetails/DocumentsDetails")
);

const PartnerDashBoard = (props) => {
  const handleSessionExpired = useSession();

  const [loader, showLoader, hideLoader] = UseFullLoader();
  const partnerSidebarDtoList =
    props?.partnerSidebarDtoList?.length > 0
      ? props?.partnerSidebarDtoList
      : [];

  // find page is equal to EngagementDetails
  const EngagementDetailStatus =
    partnerSidebarDtoList?.find((item) => item.page === "EngagementDetails")
      ?.status === "COMPLETE"
      ? true
      : false;

  const FirmDetailStatus =
    partnerSidebarDtoList?.find((item) => item.page === "FirmDetails")
      ?.status === "COMPLETE"
      ? true
      : false;
  const BranchDetailStatus =
    partnerSidebarDtoList?.find((item) => item.page === "BranchDetails")
      ?.status === "COMPLETE"
      ? true
      : false;
  const TeamDetailStatus =
    partnerSidebarDtoList?.find((item) => item.page === "TeamDetails")
      ?.status === "COMPLETE"
      ? true
      : false;

  const DocumentStatus =
    partnerSidebarDtoList?.find((item) => item.page === "Documents")?.status ===
    "COMPLETE"
      ? true
      : false;

  const routes = [
    {
      path: "/firmdetails",
      element: <FirmDetails />,
      active: EngagementDetailStatus,
    },
    {
      path: "/firmdetails/:Id",
      element: <FirmDetails />,
      active: EngagementDetailStatus,
    },
    {
      path: "/engagementDetails",
      element: <EngagementDetails />,
      active: true,
    },
    {
      path: "/engagementDetails/:Id",
      element: <EngagementDetails />,
      active: true,
    },
    {
      path: "/branchdetailsfornew",
      element: <BranchDetails />,
      active: EngagementDetailStatus && FirmDetailStatus,
    },
    {
      path: "/teamdetailsfornew",
      element: <PartnerTeamDetails />,
      active: EngagementDetailStatus && FirmDetailStatus,
    },
    {
      path: "/teamdetails",
      element: <PartnerTeamDetails />,
      active: EngagementDetailStatus && FirmDetailStatus,
    },
    {
      path: "/document",
      element: <DocumentsDetails />,
      active:
        EngagementDetailStatus &&
        FirmDetailStatus &&
        BranchDetailStatus &&
        TeamDetailStatus,
    },
    {
      path: "/branchdetails",
      element: <BranchDetails />,
      active: true,
    },
    {
      path: "/user",
      element: <UserManagement />,
      active: true,
    },
  ];
  const { width } = useWindowSize();
  const [Auth, setAuth] = useState(useSelector((state) => state.auth));
  const [loading, setLoading] = useState(true);
  const [partnerFirmName, setPartnerFirmName] = useState("");
  const Id = sessionStorage.getItem("cetFirmId");

  useEffect(() => {
    setPartnerFirmName(props.data);
  }, [props.data]);
  useEffect(() => {
    props
      .getTeamsData({
        accessToken: Auth?.accessToken?.access_token,
        partnerFirmID: props.firmId || Id,
      })
      .then((res) => {
        setLoading(false);

        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      })
      .catch((err) => {
        setLoading(false);
      });

    props
      .getBranchData({
        accessToken: Auth?.accessToken?.access_token,
        partnerFirmId: props.firmId || Id,
      })
      .then((res) => {
        setLoading(false);
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [Id]);

  useEffect(() => {
    props
      .getPartnerSidebar({
        accessToken: props.access_token,
        partnerFirmId: props.firmId || Id,
      })
      .then((res) => {
        hideLoader();
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            hideLoader();

            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      })
      .catch((e) => {
        hideLoader();
      });
  }, [Id]);

  useEffect(() => {
    props
      .GetBranchCountDetails({
        access_token: props.access_token,
        partnerFirmId: props.firmId || Id,
      })
      .then((res) => {
        hideLoader();
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            hideLoader();

            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      })
      .catch((e) => {
        hideLoader();
      });
  }, [Id]);

  return (
    !loading && (
      <div>
        {props?.LogoutFlag?.logoutFlag ? <CustomLogout /> : ""}
        {width < 786 && (
          <Row>
            <Col lg={12} xs={12} md={12} sm={12}>
              <PartnerMobileHeader />
            </Col>
          </Row>
        )}

        <Row>
          <Col
            lg={12}
            xs={12}
            md={12}
            sm={12}
            className="partner-dashboard-section"
          >
            <Col md={3} className="Left-side-blue">
              <SideMenuPartnerDashboard />
            </Col>

            <Col md={9} className="right-side-blue">
              <h4 className="partnerName">
                {partnerFirmName?.length > 20
                  ? partnerFirmName.substring(0, 20) + "..."
                  : partnerFirmName}
              </h4>
              <React.Suspense
                fallback={
                  <div className="cet-dashobard-loader">
                    <Spin
                      className="cet-loader"
                      size="large"
                      indicator={
                        <LoadingOutlined style={{ color: "#00d8db" }} />
                      }
                    ></Spin>
                  </div>
                }
              >
                <Routes>
                  <Route
                    path="*"
                    element={
                      <Navigate
                        to="/PartnerDashBoard/engagementDetails"
                        replace
                      />
                    }
                  />
                  {routes
                    ?.filter((r) => r.active)
                    .map((route, index) => (
                      <Route
                        key={index}
                        path={route.path}
                        element={route.element}
                      />
                    ))}
                </Routes>
              </React.Suspense>
            </Col>
          </Col>
        </Row>
      </div>
    )
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    LogoutFlag: state.Logout,
    data: state?.teamSideBar?.sidebarTeamsDetails?.partnerFirmName,
    state: state && state.auth,
    access_token: state?.auth?.idToken,
    editPartner: state?.editPartner?.editPartner,
    partnerFirmId:
      state.auth?.checkLogin?.partnerFirmId ||
      state?.auth?.loginCredentials?.data?.partnerFirmDetails?.partnerFirmId ||
      sessionStorage.getItem("cetFirmId"),
    partnerSidebarDtoList: state.partnerSidebar?.partnerSidebarDtoList,
    userData: state.auth?.userData,
    firmId:
      state.auth?.checkLogin?.partnerFirmId ||
      state?.auth?.loginCredentials?.data?.partnerFirmDetails?.partnerFirmId ||
      sessionStorage.getItem("cetFirmId"),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTeamsData: (data) => dispatch(getTeamSideBarDetails(data)),
    getBranchData: (data) => dispatch(getSideBarBranch(data)),
    getPartnerSidebar: (data) => dispatch(getPartnerSidebar(data)),
    GetBranchCountDetails: (data) => dispatch(GetBranchCountDetails(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PartnerDashBoard);
